import Api from 'libs/api/index';

class DomainEmailsApi extends Api {
  constructor() {
    super('domain_emails');
  }
}

export default DomainEmailsApi;
